module.exports = __webpack_public_path__ + "media/categories/1017-a6fb144a.svg";